// extracted by mini-css-extract-plugin
module.exports = {"heroGradient":"HeroGradient_heroGradient__OHlVe","canvas":"HeroGradient_canvas__1YNtB"};